






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";

@Component
export default class VacationForm extends Vue {
  @Prop({ default: false }) value!: boolean;
  // eslint-disable-next-line
  @Prop({ default: () => null }) initialData!: any;

  valid = true;
  dateRangeMode = false;
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");

  // eslint-disable-next-line
  formData: any = {
    employeeId: undefined,
    reason: "",
  };

  date = "";
  dateRange: string[] = [];

  get selectedDateLabel(): string {
    if (this.dateRange.length === 2)
      return `Selected: ${moment(this.dateRange[0]).format(
        "MMM D, YYYY",
      )} - ${moment(this.dateRange[1]).format("MMM D, YYYY")}`;
    if (this.date)
      return `Selected: ${moment(this.date).format("MMM D, YYYY")}`;
    return "No date selected";
  }

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  get employees() {
    const employeesList = this.$store.state.directory.employees ?? [];
    return _.map(
      _.orderBy(employeesList, [
        employee => `${employee.firstName} ${employee.lastName}`.toLowerCase(),
      ]),
      employee => ({
        ...employee,
        text: `${employee.firstName} ${employee.lastName}`,
      }),
    );
  }

  clearCalendar() {
    this.date = "";
    this.dateRange = [];
  }

  @Watch("value")
  onDialogChange(newVal: boolean) {
    if (newVal) {
      this.resetForm();
    }
  }

  @Watch("initialData", { deep: true })
  // eslint-disable-next-line
  onInitialDataChange(newVal: any) {
    if (newVal) {
      if (newVal.employeeId) {
        this.formData.employeeId = newVal.employeeId;
      }
      if (newVal.date) {
        this.date = newVal.date;
        this.dateRange = [newVal.date];
      }
    }
  }

  @Watch("dateRangeMode")
  onDateRangeModeChange(newVal: boolean) {
    if (!newVal) {
      this.dateRange = [];
    } else if (!this.dateRange[1]) {
      this.dateRange = [
        this.dateRange[0] || this.date,
        this.dateRange[0] || this.date,
      ];
    }
  }

  @Watch("date")
  onDateChange(newVal: string) {
    if (newVal && !this.dateRangeMode) {
      this.dateRange = [newVal];
    }
  }

  @Watch("dateRange", { deep: true })
  onDateRangeChange(newVal: string[]) {
    if (newVal && newVal.length === 2) {
      this.date = newVal[0];
    }
  }

  resetForm() {
    this.dateRangeMode = false;
    this.date = "";
    this.dateRange = [];
    this.formData = {
      employeeId: this.initialData?.employeeId || undefined,
      reason: "",
    };
    if (this.initialData?.date) {
      this.date = this.initialData.date;
      this.dateRange = [this.initialData.date];
    }
    if (this.$refs.form) {
      // eslint-disable-next-line
      (this.$refs.form as any).resetValidation();
    }
  }

  close() {
    this.dialog = false;
  }

  save() {
    // eslint-disable-next-line
    if (!(this.$refs.form as any).validate()) return;

    const isRange = this.dateRangeMode && this.dateRange.length === 2;
    const startDate = isRange ? this.dateRange[0] : this.date;
    const endDate = isRange ? this.dateRange[1] : this.date;

    const payload = {
      employeeId: this.formData.employeeId,
      startDate,
      endDate,
      reason: this.formData.reason || undefined,
    };

    this.$store.dispatch("vacation/addVacation", payload);
    this.dialog = false;
  }
}
